(function () {
  function normalizeLetter(value) {
    var first = (value || '').trim().charAt(0);
    return /[\u0600-\u06FF]/.test(first) ? first : first.toLocaleUpperCase();
  }

  function isArabic() {
    return document.documentElement.lang.indexOf('ar') === 0 ||
      document.querySelector('[data-brand-filter]') &&
      /[\u0600-\u06FF]/.test(document.querySelector('[data-brand-filter]:not([data-brand-filter="all"])').dataset.brandFilter || '');
  }

  function initAllBrands(section) {
    var grid = section.querySelector('[data-brands-grid]');
    var buttons = section.querySelectorAll('[data-brand-filter]');
    var titleText = section.querySelector('[data-brands-title-text]');
    var countText = section.querySelector('[data-brands-count]');

    if (!grid || !buttons.length) {
      return;
    }

    var arabic = isArabic();
    var brandsSuffix = arabic ? ' ماركات' : ' Brands';

    var cards = Array.from(grid.querySelectorAll('[data-brand-card]'));

    cards
      .sort(function (a, b) {
        return (a.dataset.brandName || '').localeCompare(b.dataset.brandName || '', undefined, {
          sensitivity: 'base',
        });
      })
      .forEach(function (card) {
        grid.appendChild(card);
      });

    function setActive(button) {
      buttons.forEach(function (item) {
        item.classList.toggle('is-active', item === button);
        item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
      });
    }

    function updateTitle(label, visibleCount, totalCount) {
      if (titleText) {
        titleText.textContent = label || 'All Brands';
      }

      if (countText) {
        countText.textContent = '(' + (visibleCount || totalCount || 0) + ')';
      }
    }

    function filterCards(button) {
      var selectedLetter = button.dataset.brandFilter;
      var label = button.dataset.brandLabel || button.textContent.trim();
      var visibleCount = 0;

      cards.forEach(function (card) {
        var shouldShow = selectedLetter === 'all' || normalizeLetter(card.dataset.brandName) === selectedLetter;
        card.hidden = !shouldShow;

        if (shouldShow) {
          visibleCount += 1;
        }
      });

      setActive(button);
      updateTitle(selectedLetter === 'all' ? (arabic ? 'كل الماركات' : 'All Brands') : label + brandsSuffix, visibleCount, cards.length);
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        filterCards(button);
      });
    });

    var initialButton = section.querySelector('[data-brand-filter="all"]') || buttons[0];
    filterCards(initialButton);
  }

  function initSections(root) {
    (root || document).querySelectorAll('[data-metaobject-all-brands]').forEach(initAllBrands);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initSections(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initSections(event.target);
  });
})();